<template>
    <b-dropdown id="lang_choice"  variant="outline-success" class="p-0 btn-group" no-caret >
        <template  v-slot:button-content>
            <button type="button" class="btn btn-outline-default waves-effect waves-themed">
                <span class="fal fa-globe mr-1"></span>
                {{cur_locale.toUpperCase()}}
            </button>
        </template>
        <b-dropdown-form class="change_locale">
            <b-dropdown-item :key="locale" v-for="locale in locales_list" v-on:click="set_locale(locale)">
                <span class="fal fa-globe mr-1"></span>
                {{locale.toUpperCase()}}
            </b-dropdown-item>
        </b-dropdown-form>
    </b-dropdown>
</template>

<script>
    export default {
        name: "lang",
        props : {
            locales : {
                type : Array,
                required : true
            },
            cur_locale : {
                type : String,
                default : "ru"
            }
        },

        methods : {
            set_locale(locale) {
                api.put('/locale/'+ locale).then(({data}) => {
                    if (data.status === "operation_success") {
                        window.location.reload();
                    }
                }).catch(({response}) => {
                    EventBus.$emit('show_toast', {
                        err: response.data.message, type: "danger",
                        title: response.data.status,
                        position : "b-toaster-top-left"
                    })
                });
            }
        },

        computed : {
            locales_list() {
                return this.locales.filter(item => {
                    return item != this.cur_locale;
                })
            },
        },


    }
</script>

<style scoped>

</style>
